import useLoginStore from '@/store/LoginStore'

export function useWorkspaceMode() {
  const workspaceType = useLoginStore((s) => s.workspaceType)
  const isPersonal = workspaceType === 1
  return { isPersonal, isTeam: !isPersonal }
}
